import React, { useState } from "react";

const PasswordInput = ({
  label,
  required,
  placeholder,
  value,
  onChange,
  isRegistration = false, // Pass `true` for registration, false for login
  id, // Add id prop
  className = "", // Add className prop with default empty string
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [error, setError] = useState("");

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    let errorMessage = "";

    if (required && !inputValue.trim()) {
      errorMessage = "Ce champ est obligatoire.";
    } else if (isRegistration && inputValue.length > 0 && inputValue.length < 8) {
      errorMessage = "Le mot de passe doit contenir au moins 8 caractères.";
    }

    setError(errorMessage);
    onChange(e);
  };

  return (
    <div className="">
      <div className="input-wrapper password">
        {label && (
          <label htmlFor={id}>
            {label}
            {required && <span> *</span>}
          </label>
        )}
        <div className="password-input-wrapper">
          <input
            id={id} // Use the id prop
            type={isVisible ? "text" : "password"} // Toggle between text and password
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onCopy={(e) => e.preventDefault()}
            onPaste={(e) => e.preventDefault()}
            onCut={(e) => e.preventDefault()}
            className={className} // Apply the passed className
          />
          <span className="visibility-toggle" onClick={toggleVisibility}>
            <img
              src={isVisible ? "/images/eye-closed.svg" : "/images/eye-open.png"}
              alt="eye toggle"
              width={24}
              height={24}
            />
          </span>
        </div>
      </div>
      {/* {error && (
        <small className="error-message mt-8">
          <img src="/images/alert-circle.svg" className="arrow mr-8" alt="Arrow" />
          {error}
        </small>
      )} */}
      {isRegistration && (
        <span className={`mt-8 ${error ? "error-message" : "legend grey66"}`}>
          {error && (
            <img src="/images/alert-circle.svg" className="arrow mr-8" alt="Alert" />
          )}
          Le mot de passe doit faire plus de 8 caractères
        </span>
      )}
    </div>
  );
};

export default PasswordInput;